module.exports = __webpack_public_path__ + "static/media/Slider2_trendthemen.5270ca69.jpg";